import {defineStore} from 'pinia'


export const useProgressBarStore = defineStore('progressbar', {
    state: () => ({
        steps: [
            {name: 'Daten zum Mieter', number: '1', state: 'current'},
            {name: 'Mietobjekt & Zahlung', number: '2', state: 'upcoming'},
            {name: 'Geschafft!', number: '3', state: 'upcoming'},
        ]
    }),
    actions: {
        setStepsState(step) {
            switch (step) {
                case 'start':
                    this.steps[0].state = 'current';
                    this.steps[1].state = 'upcoming';
                    this.steps[2].state = 'upcoming';
                    break;
                case 'next':
                    this.steps[0].state = 'complete';
                    this.steps[1].state = 'current';
                    this.steps[2].state = 'upcoming';
                    break;
                case 'danke':
                    this.steps[0].state = 'complete';
                    this.steps[1].state = 'complete';
                    this.steps[2].state = 'complete';
                    break;
            }
        }
    },
});